import React, { memo } from 'react';
import styled from 'styled-components';

interface ITag {
  className?: string;
  tag: string;
  as?: keyof JSX.IntrinsicElements;
}

const Tag = ({ tag, ...props }: ITag) => {
  if (!tag) return null;

  return (
    <StyledTag title={tag} {...props}>
      {tag}
    </StyledTag>
  );
};

const StyledTag = styled.span`
  color: inherit;
  font-size: 12px;

  ::before {
    content: '#';
  }
`;

export default memo(Tag);
